import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TypeUtilService {
  constructor() {
  }

  /**
   * 是否字符串
   */
  isString(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'String';
  }

  /**
   * 是否数字
   */
  isNumber(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Number';
  }

  /**
   * 是否boolean
   */
  isBoolean(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Boolean';
  }

  /**
   * 是否函数
   */
  isFunction(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Function';
  }

  /**
   * 是否为null
   */
  isNull(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Null';
  }

  /**
   * 是否undefined
   */
  isUndefined(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Undefined';
  }

  /**
   * 是否对象
   */
  isObject(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Object';
  }

  /**
   * 是否数组
   */
  isArray(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Array';
  }

  /**
   * 是否时间
   */
  isDate(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Date';
  }

  /**
   * 是否时间戳
   */
  isTimestamp(n: any): boolean {
    return /^\d{10,13}$/.test(n);
  }

  /**
   * 是否正则
   */
  isRegExp(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'RegExp';
  }

  /**
   * 是否错误对象
   */
  isError(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Error';
  }

  /**
   * 是否Symbol函数
   */
  isSymbol(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Symbol';
  }

  /**
   * 是否Promise对象
   */
  isPromise(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Promise';
  }

  /**
   * 是否Set对象
   */
  isSet(o: any): boolean {
    return Object.prototype.toString.call(o).slice(8, -1) === 'Set';
  }

  /**
   * 是否是 JSON
   */
  isJSON(o: string): boolean {
    if (this.isString(o) && o.length) {
      if (o.startsWith('{') && o.endsWith('}')) {
        return true;
      } else if (o.startsWith('[') && o.endsWith(']')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /**
   * 否判断
   */
  isFalse(o: any): boolean {
    if (o === '' || o === undefined || o === 'null' || o === 'undefined' || o === 0 || o === false || (typeof o === 'number' && isNaN(o))) {
      return true;
    }
    return false;
  }

  /**
   * 是判断
   */
  isTrue(o: any): boolean {
    return !this.isFalse(o);
  }

  /**
   * 判断是否为空值
   */
  isNullValue(value: any): boolean {
    return !!(value === undefined || value === null || value === '' || value === 'null' || value === 'undefined' || (typeof value === 'number' && isNaN(value)));
  }
}
